import React, { Component } from "react";
import classNames from "classnames";
import selectn from "selectn";
import { Link } from "react-router-dom";
import formatPublishedDate from "../../../utils/formatPublishedDate";

import { FRONTEND_ROOT } from "../../../config/constants";
import styles from "./MiniStoryCard.css";
import { HeaderContext } from "../../../config/contexts";

class MiniStoryCard extends Component {
  render() {
    const latest = this.props.latest;
    if (!latest) return null;
    const section =
      latest.content_type === "newsletter"
        ? "Newsletters"
        : selectn("primary_section.name", latest);
    const publishedDateFormatted = formatPublishedDate(
      latest.last_published || latest.published_date,
      latest.status
    );
    const divider =
      (latest.is_featured || publishedDateFormatted) && section && " / ";

    return (
      <HeaderContext.Consumer>
        {headerLevels => {
          const HeadingTag = "h" + headerLevels.miniStoryCardHeader;
          return (
            <div key={latest.id} className={styles.root}>
              <Link
                innerRef={this.props.storyCardRef}
                className={classNames(styles.headline, this.props.className)}
                to={latest.permalink.replace(FRONTEND_ROOT, "")}
              >
                <HeadingTag className={styles.headline}>
                  {latest.headline}
                </HeadingTag>
              </Link>
              <div className={styles.subtext}>
                {latest.is_featured ? (
                  <span className={styles.featured}>Featured</span>
                ) : (
                  publishedDateFormatted
                )}
                {divider}
                {section}
              </div>
            </div>
          );
        }}
      </HeaderContext.Consumer>
    );
  }
}

export default MiniStoryCard;
